import { SHOW_LOADER, HIDE_LOADER } from "../actions/loaderActions"

const initialState = {
    loaderState: {
        show: false
    }
}

const loaderReducer =(state = initialState, action:any) => {
    const newState = { ...state };
    switch (action.type) {
        case SHOW_LOADER: {
            newState.loaderState = action.payload
            return newState
        }
        case HIDE_LOADER: {
            newState.loaderState = action.payload
            return newState
        }
        default:
            return newState
    }
}
export default loaderReducer;